
export enum AgreementStatus {
    Unsigned = 1,
    CustomerSigning = 2,
    CustomerSigned = 3,
    CustomerDeclined = 4,
    Signed = 5,
    CsaDeclined = 6
}
